// src/theme/RouteTheme.tsx
import React from "react";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { createAppTheme } from "theme";
import type { ColorMode } from "theme/types"; // or just inline "light" | "dark"

export default function RouteTheme({
  mode,
  children,
}: {
  mode: ColorMode; // "light" | "dark"
  children: React.ReactNode;
}) {
  const theme = React.useMemo(() => createAppTheme(mode), [mode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
